import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

if ("serviceWorker" in navigator) {
  const mf = document.querySelector('link[rel="manifest"]');
  if (mf && window.location.pathname.startsWith("/portal")) mf.href = "/manifest-portal.json";
  else if (mf && (window.location.pathname === "/m" || window.location.pathname.startsWith("/m/"))) mf.href = "/manifest-field.json";
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").then((reg) => { window.addEventListener("online", () => reg.active?.postMessage({ type: "replay" })); }).catch(() => {});
  });
}
